import timings from 'timings'

class Animation {

  constructor (options) {
    this.chart = options.chart

    this.scalers = options.scalers

    this.serieScale = options.serieScale
    this.previous = options.previous
    this.duration = options.duration
    this.delay = options.delay
    this.seriesChanged = options.seriesChanged
    this.series = options.series
    this.exitingSeries = options.exitingSeries
    this.totalDuration = options.totalDuration
    this.plotId = options.plotId

    this.reverseTransition = false // By default transitions are in the order of the elements

    if (this.chart.previous) {
      this.previous.scalers = this.chart.previous.scalers
    }
    if (!this.previous.scalers) {
      this.previous.scalers = {} // Safety check so code can check if there is previous.scalers.{x,y}
    }
  }

  configure (axis) {
    if (axis) {
      // If the animation is bound to an axis, set the axis and yscale as convienence
      // objects
      this.axis = axis
      this.yScale = this.scalers.y[axis]
      this.previous.yScale = this.previous.scalers.y && this.previous.scalers.y[axis]
    }

    this.timing = this.timings()

    return this
  }

  match () {
    throw new TypeError('Must be implemented by subclass')
  }

  animate () {
    throw new TypeError('Must be implemented by subclass')
  }

  timings () {
    let scale = this._timingScale ? this._timingScale() : this.scalers.x.groupScale
    return timings({
      scale,
      totalDuration: this.totalDuration,
      twoPart: this.twoPart,
      ripple: this.ripple,
      reverse: this.reverseTransition,
      delayFactor: this.delayFactor,
      accessor: 'rangeId'
    })
  }

}

export default Animation
